module.exports = __webpack_public_path__ + "static/tasha_s_hideous_laughter-mtg_afr-53ec63349ea05e88a86fa882ddedf8f8.jpg";